// extracted by mini-css-extract-plugin
export default {"container":"tQ0Q1A"};